/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Points awarded per match outcome. Field names match the LeaguePointsConfig model and the admin UI's submit shape. Prior shorthand (`win`/`draw`/`loss`) was renamed to `pointsPerWin`/`pointsPerDraw`/`pointsPerLoss` after R1 round-2 review surfaced that the old keys never matched what the admin frontend sent — operator points entries were silently dropped to defaults. Do not reintroduce the shorthand on either create or update.
 * @export
 * @interface UpdateLeagueBodyPointsConfig
 */
export interface UpdateLeagueBodyPointsConfig {
    /**
     * 
     * @type {number}
     * @memberof UpdateLeagueBodyPointsConfig
     */
    pointsPerWin?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLeagueBodyPointsConfig
     */
    pointsPerDraw?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLeagueBodyPointsConfig
     */
    pointsPerLoss?: number;
}

/**
 * Check if a given object implements the UpdateLeagueBodyPointsConfig interface.
 */
export function instanceOfUpdateLeagueBodyPointsConfig(value: object): value is UpdateLeagueBodyPointsConfig {
    return true;
}

export function UpdateLeagueBodyPointsConfigFromJSON(json: any): UpdateLeagueBodyPointsConfig {
    return UpdateLeagueBodyPointsConfigFromJSONTyped(json, false);
}

export function UpdateLeagueBodyPointsConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeagueBodyPointsConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'pointsPerWin': json['pointsPerWin'] == null ? undefined : json['pointsPerWin'],
        'pointsPerDraw': json['pointsPerDraw'] == null ? undefined : json['pointsPerDraw'],
        'pointsPerLoss': json['pointsPerLoss'] == null ? undefined : json['pointsPerLoss'],
    };
}

export function UpdateLeagueBodyPointsConfigToJSON(json: any): UpdateLeagueBodyPointsConfig {
    return UpdateLeagueBodyPointsConfigToJSONTyped(json, false);
}

export function UpdateLeagueBodyPointsConfigToJSONTyped(value?: UpdateLeagueBodyPointsConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pointsPerWin': value['pointsPerWin'],
        'pointsPerDraw': value['pointsPerDraw'],
        'pointsPerLoss': value['pointsPerLoss'],
    };
}

